import { topRankings } from '@/mocks/animeData';

export default function TopRanking() {
  const top3 = topRankings.slice(0, 3);
  const rest = topRankings.slice(3);

  return (
    <section id="ranking" className="py-14 md:py-20 bg-background-50 scroll-mt-20">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-10">
          <h2 className="font-heading text-2xl md:text-3xl text-foreground-950 mb-3">热门排行榜</h2>
          <p className="text-sm text-foreground-600">综合评分与热度，最受欢迎的成人动漫作品</p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-5 mb-8">
          {top3.map((item) => (
            <div
              key={item.rank}
              className="bg-background-100 rounded-2xl p-5 flex items-center gap-5 transition-all duration-300 hover:-translate-y-1"
            >
              <div className={`w-14 h-14 rounded-xl flex items-center justify-center flex-shrink-0 ${
                item.rank === 1
                  ? 'bg-accent-500 text-background-50'
                  : item.rank === 2
                    ? 'bg-secondary-500 text-background-50'
                    : 'bg-primary-500 text-background-50'
              }`}>
                <span className="font-heading text-2xl">{item.rank}</span>
              </div>
              <div className="min-w-0">
                <h3 className="font-heading text-base text-foreground-900 mb-1 truncate">{item.title}</h3>
                <div className="flex items-center gap-2 text-xs text-foreground-500">
                  <span>{item.category}</span>
                  <span className="text-accent-500 font-bold">{item.rating}</span>
                </div>
                <p className="text-xs text-foreground-400 mt-1">{item.hot}</p>
              </div>
            </div>
          ))}
        </div>

        <div className="bg-background-100 rounded-2xl p-5 md:p-6">
          <div className="divide-y divide-background-200/70">
            {rest.map((item) => (
              <div
                key={item.rank}
                className="flex items-center gap-4 py-3 first:pt-0 last:pb-0 transition-colors hover:bg-primary-50/50 px-2 -mx-2 rounded-lg"
              >
                <span className="w-8 h-8 rounded-lg bg-secondary-100 flex items-center justify-center text-sm font-bold text-secondary-600 flex-shrink-0">
                  {item.rank}
                </span>
                <span className="font-heading text-sm text-foreground-800 flex-1 truncate">{item.title}</span>
                <span className="text-xs text-foreground-500 flex-shrink-0 w-16 text-center">{item.category}</span>
                <span className="text-sm font-bold text-primary-500 flex-shrink-0 w-10 text-right">{item.rating}</span>
                <span className="text-xs text-foreground-400 flex-shrink-0 w-20 text-right">{item.hot}</span>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}